<template>
    <section class="gh-form-registration-summit gh-form-registration-suicidePreventionSummit">
        <div v-show="false" class="gh-summit-section">
            <gh-impact :impact="form.impact" @updateImpact="updateImpact"/>
        </div>

        <div id="registration" class="gh-summit-section pt-1 gh-form--registration"
            v-loading.fullscreen.lock="isProcessing" element-loading-text="We're processing your registration...">
            <div class="gh-form__wrapper container">
                <h4 class="section-heading gh-heading">Complete your registration</h4>
                <p class="gh-subheading">Reserving your place at the 2022 Suicide Prevention Summit only takes a minute and it's completely secure. Just select your registration type and fill in your details below, and click ‘Submit Registration.’ </p>

                <el-form :model="form" status-icon ref="elForm2" class="gh-form">
                    <!-- Profile -->
                    <el-form-item id="gh-registration-from__banner">
                        <el-radio-group v-model="form.impact" style="width: 100%; margin-top: 20px">
                            <el-row class="gh-row-radio-group" :gutter="50">
                                <el-col class="gh-col-radio-group" :xs="24" :md="12">
                                    <div class="gh-box" :class="form.impact === 10 ? 'gh-selected' : ''">
                                        <el-radio :label="10">
                                            <div class="gh-impact-label">
                                                <div class="gh-box-price">
                                                    <p class="gh-hint">Premium Access</p>
                                                    <span class="gh-box-price-value">
                                                        <span class="gh-dollar-sign">£</span>
                                                        <span class="gh-price">10</span>
                                                    </span>
                                                </div>
                                                <div class="gh-includes">
                                                    <ul>
                                                        <li class="flexTest">
                                                            <img width="20" height="20"
                                                                src="/images/suicidePreventionSummit/Tick@2x.png"
                                                                alt="">
                                                            <span>Live Webinars (Sep 10-11)</span>
                                                        </li>
                                                        <li class="flexTest">
                                                            <img width="20" height="20"
                                                                src="/images/suicidePreventionSummit/Tick@2x.png"
                                                                alt="">
                                                            <span>8-week access to recordings</span>
                                                        </li>
                                                        <li class="flexTest">
                                                            <img width="20" height="20"
                                                                src="/images/suicidePreventionSummit/Tick@2x.png"
                                                                alt="">
                                                            <span>Session slides (download)</span>
                                                        </li>
                                                        <li class="flexTest">
                                                            <img width="20" height="20"
                                                                src="/images/suicidePreventionSummit/Tick@2x.png"
                                                                alt="">
                                                            <span>Post-session notes (download)</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </el-radio>
                                    </div>
                                </el-col>

                                <el-col class="gh-col-radio-group" :xs="24" :md="12">

                                    <div class="gh-box" :class="form.impact === 0 ? 'gh-selected' : ''">
                                        <div class="backing">
                                          <h2 id="closeText">Free Registration Closed</h2>
                                        </div>
                                        <el-radio :label="0" :disabled="true">
                                            <div class="gh-impact-label">
                                                <div class="gh-box-price">
                                                    <p class="gh-hint">Free Registration</p>
                                                    <span class="gh-box-price-value">
                                                        <span class="gh-dollar-sign">£</span>
                                                        <span class="gh-price">0</span>
                                                    </span>
                                                </div>
                                                <div class="gh-includes">
                                                    <ul>
                                                        <li class="flexTest">
                                                            <img width="20" height="20"
                                                                src="/images/suicidePreventionSummit/Tick@2x.png"
                                                                alt="">
                                                            <span>Live Webinars (Sep 10-11)</span>
                                                        </li>
                                                        <li class="flexTest">
                                                            <img width="20" height="20"
                                                                src="/images/suicidePreventionSummit/Tick@2x.png"
                                                                alt="">
                                                            <span>7-day access to recordings</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </el-radio>
                                    </div>
                                </el-col>
                              <!-- Free registration -->
                              <!-- <el-col class="gh-col-radio-group" :xs="24" :md="12">
                                  <div class="gh-box" :class="form.impact === 0 ? 'gh-selected' : ''">
                                      <el-radio :label="0">
                                          <el-row :gutter="30">
                                              <el-col :span="24" class="gh-boxes">
                                                  <p class="gh-box-price">
                                                      <span class="gh-hint">Free Registration</span>
                                                      <span>
                                                          <span class="gh-dollar-sign">$</span>
                                                          <span class="gh-price">0</span>
                                                      </span>
                                                  </p>
                                              </el-col>
                                              <el-col class="text-dark-blue">
                                                  <div class="gh-includes">
                                                      <ul>
                                                          <li>
                                                              <img width="20" height="20" src="/images/suicidePreventionSummit/Tick@2x.png" alt="">
                                                              <span>Live Webinars (Aug 19-21)</span>
                                                          </li>
                                                          <li>
                                                              <img width="20" height="20" src="/images/suicidePreventionSummit/Tick@2x.png" alt="">
                                                              <span>7-day access to recordings</span>
                                                          </li>
                                                      </ul>
                                                  </div>
                                              </el-col>
                                          </el-row>
                                      </el-radio>
                                  </div>
                              </el-col> -->
                            </el-row>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div id="gh-registration__form" class="gh-summit-section pt-1 gh-form--registration"
            v-loading.fullscreen.lock="isProcessing" element-loading-text="We're processing your registration...">
            <div class="gh-form__wrapper container">
                <el-form :model="form" :rules="form.validationRules" status-icon
                    @keyup.enter.native="attemptSubmit('elForm')" ref="elForm" class="gh-form">
                    <!-- Profile -->
                    <div class="gh-form__section">
                        <el-row :gutter="innerGutter">
                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="firstName" :class="form.firstName ? 'has-value' : ''">
                                    <label class="gh-form__label">First Name</label>
                                    <el-input v-model="form.firstName" name="firstName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="lastName" :class="form.lastName ? 'has-value' : ''">
                                    <label class="gh-form__label">Last Name</label>
                                    <el-input v-model="form.lastName" name="lastName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="email" :class="form.email ? 'has-value' : ''">
                                    <label class="gh-form__label">Email</label>
                                    <el-input v-model="form.email" type="email" name="email"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="email_confirmation"
                                    :class="form.email_confirmation ? 'has-value' : ''">
                                    <label class="gh-form__label">Confirm Email</label>
                                    <el-input v-model="form.email_confirmation" type="email"
                                        name="email_confirmation"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="professionId" :class="form.professionId ? 'has-value' : ''">
                                    <label class="gh-form__label">Your Profession</label>
                                    <gh-profession-selector class="gh-profession-selector" :initial="form.professionId"
                                        @change="changeProfession" :excludes="excludedProfessions"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item prop="country" :class="form.country ? 'has-value' : ''">
                                    <label class="gh-form__label ">Country</label>
                                    <gh-country-selector @change="changeCountry" :initial="form.country"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                  <!-- TnC -->
                    <div class="tnc">
                        <p class="gh-form__heading">Amount payable: <span class="gh-price"> £{{ form.impact }}</span></p>
                        <el-form-item prop="accept">
                            <el-checkbox v-model="form.accept" class="term-checkbox">
                                I have read and agree to the 2022 Suicide Prevention Summit <a @click.stop.prevent="showDialog">Terms and Conditions.</a>
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item prop="acceptMailingList">
                            <el-checkbox v-model="form.acceptMailingList" class="term-checkbox">
                                I agree to receive email communications, including special offers and further CPD opportunities, from Mental Health Academy.
                            </el-checkbox>
                        </el-form-item>
                    </div>

                        <vue-recaptcha ref="recaptcha" :sitekey="recaptchaSitekey" size="invisible" badge="bottomleft"
                            :loadRecaptchaScript="true" @verify="setRecaptchaToken"/>

                  <!-- Actions -->
                    <div class="gh-form__actions mt-1">
                        <el-button
                            class="gh-button--summit gh-button-registration border-none bg-pink bg-hover-light-pink text-white mt-1"
                            @click="attemptSubmit('elForm')" :disabled="isProcessing">
                            Submit Registration
                        </el-button>
                    </div>
                </el-form>
                <gh-terms :dialogVisible="dialogVisible" @hide="dialogVisible=false" />
            </div>
        </div>
    </section>
</template>

<script>
    import registrationMixin from '@/modules/registration/mixins/registration';
    import ghCountrySelector from '@/components/forms/components/country/countrySelector';
    import ghImpact from '@/modules/events/suicidePreventionSummit/components/Impact'
    import Form from '@/modules/form/models/Form';
    import ghProfessionSelector from '@/modules/profession/components/ProfessionSelector'
    import ghTerms from './TermsRegistration';

    export default {
      mixins: [registrationMixin],

      components: {
        ghImpact,
        ghProfessionSelector,
        ghCountrySelector,
        ghTerms
      },

      props: {
        eventId: {
          type: Number,
          required: true
        }
      },

      data() {
        return {
          form: new Form({
            firstName: '',
            lastName: '',
            professionId: 'dze5z',
            contactNumber: '',
            email: '',
            country: '',
            email_confirmation: '',
            accept: false,
            acceptMailingList: false,
            recaptcha: '',
            impact: 10,
            cardName: '',
            registrationType: 'premium'

          }),
          dialogVisible: false
        }
      },
      created() {
        this.onResize()
        window.addEventListener('resize', this.onResize)
      },
      computed: {
        outerGutter() {
          return this.device === 'mobile' ? 10 : 60
        },

        innerGutter() {
          return this.device === 'mobile' ? 0 : 30
        },

        excludedProfessions() {
          return ['GP/Medical Practitioner']
        },

        device() {
          return this.$store.getters['ui/getDevice'];
        }
      },
      methods: {
        showDialog() {
          this.dialogVisible = true;
        },

        changeCountry(country) {
          this.form.country = country;
        },

        updateImpact(value) {
          this.form.impact = value
        },
        changeProfession(profession) {
          this.form.professionId = profession;
        },
        onResize() {

          if (window.innerWidth >= 768) {
            this.impact = true
          } else {
            this.impact = false
          }
        },

        setRecaptchaToken(token) {
          this.form.recaptcha = token

          if (this.form.impact === 10) {
          } else {
            this.freeRegistration()
          }
        },

        freeRegistration() {
          this.form.registrationType = 'free'
          const customData = {
            registrationSource: this.$route.path
          };

          this.form.post(`/api/v1/events/summits/6/register/free`, customData)
              .then(({data}) => {
                this.$store.commit('event/SET_REGISTRATION_SUCCESS_STATE', true);
                this.$router.push('/suicideprevention/confirmation');
              })
              .catch(({data}) => {
                this.formFailure(data)
              });
        },
      }
    }
</script>
<style lang="scss" scoped>
    .gh-summit-section {
        padding: 2rem 0;
    }

    #registration {
      background-image: linear-gradient(to right, #61B3E4, #64A3D8, #63A7DC, #648EC9, #6981bc, #6a72ad);
      // background-color: red;
    }
    .gh-form-registration-suicidePreventionSummit {
        font-family: proxima-nova,sans-serif;
    }

    .gh-form__actions {
      margin-top: 1rem;
    }

    .gh-box-price-value {
      position: absolute;
      right: 100px;
      top: -1rem;
    }

    .flexTest {
      display: flex;
      align-items: center;
      margin-top: 1rem;
      font-size: 1.1rem;
      color: #474F59;

      img {
        width: 20px;
        margin-right: .5rem;
      }
    }

    #registration .gh-heading, #registration .gh-subheading {
      color: white;
    }

    #gh-registration__form {
      padding: 0 3.5rem 3.5rem;
      background-color: #fff;
    }

    .section-heading {
        font-size: 2.5rem;
    }

    .el-button {
      padding: 1.1rem 2.7rem;
    }

    .gh-form__heading--paymentDetails {
      font-size: 1.5rem !important;
    }

    .font-small {
      font-size: 1.1rem;
    }

    .gh-el-row-outer {
      margin-left: 0 !important;
      margin-right: 0 !important;

      .gh-el-col-outer {
        margin-left: 0 !important;
        margin-right: 0 !important;
      }
    }

    .gh-button--summit {
      color: white;
      background: #fc6161;
      border: none;

      &:active {
        color: white;
      }

      &focus {
        color: white;
        background: #ff5c5c;
      }
    }

    .el-button:focus, .el-button:hover {
      color: white;
      border-color: #f19999;
      background-color: #f19999;
    }

    .el-radio__inner {
      background-color: #474F59;
    }

    .el-radio {
      color: #474F59;
      font-weight: 600;
      display: flex;
    }

    .el-radio-group {
      margin-bottom: 1.6rem;

      .gh-row-radio-group {
        display: flex;
      }

      .gh-col-radio-group {
        display: grid;
      }

      .gh-box {
        position: relative;
        border: 2px solid #fff;
        transition: .3s;
        border-radius: 3%;

        &.is-inactive {
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            background: rgba(0, 0, 0, 0.5);
          }
        }

        .el-row {
          ul {
            padding-bottom: 1rem;

            li {
              display: flex;
              flex-flow: row nowrap;
              align-items: center;
              margin-top: 1rem;
              font-size: 1.1rem;
              color: #474F59;

              img {
                width: 20px;
                margin-right: .5rem;
              }
            }
          }
        }

        .gh-includes {
          margin-left: -2rem;
          font-weight: 600;
          padding-top: 5rem;

          p {
            font-size: 1.1rem;
            color: #474F59;
          }
        }

        .gh-price {
          font-size: 5rem;
          font-weight: 700;
          padding-left: 1rem;
          padding-right: .5rem;
          color: #474F59;
          position: absolute;
          padding-left: 1.3rem;
          padding-right: .5rem;
          top: 3px;
        }

        .gh-dollar-sign {
          font-size: 2.4rem;
          font-weight: 700;
          position: absolute;
          color: #474F59;
          top: 25px;
          margin-right: 28px;
        }

        &.gh-selected {
          border: 2px solid #F76B6B;
        }

        &:hover {
          box-shadow: 0px 0px 15px 2px rgba(155, 154, 154, 0.9);
        }
      }
    }

    .gh-form {
      max-width: 840px;
      margin: auto;
    }

    .gh-form__section {
      padding-top: 3.5rem;
    }

    .gh-payment-hint {
      margin-top: 1rem;
      margin-bottom: -1.5rem;
      text-align: right;
    }

    .gh-form__actions {
      @media (max-width: 767px) {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .gh-heading {
      text-align: center;
      font-weight: 600;
    }

    .gh-subheading {
      font-size: 1.3rem;
      max-width: 932px;
      text-align: center;
      margin: 2rem auto;
      font-weight: 600;
    }

    .gh-stripe {
      background-color: transparent;
    }

    .gh-form__heading {
      font-size: 1.6rem;
      margin-bottom: 20px;
    }


    .el-form-item__content:focus-within, .el-form-item.has-value {
      .gh-form__label {
        color: #F76B6B;
      }
    }


    .el-form-item.has-value .gh-form__label {
      color: #474F59;
    }

    .el-form-item__content:active {
      .gh-form__label {
        background: white;
      }
    }

    .gh-box {
      background-color: white;
      padding: 0px 15px 20px 23px;

      .gh-box-header {
        font-size: 1.6rem;
        font-weight: 600;
        line-height: 1;
      }

      .gh-box-item {
        padding: 10px 0;

        .el-col {
          line-height: 1.4;
        }

        i {
          font-size: 30px;
        }
      }

      .gh-box-item-underline {
        padding-bottom: 1rem;
        border-bottom: 1px solid rgb(236, 236, 236);
      }
    }

    .gh-impact-table {
      display: flex;

      .el-col {
        border: 1px solid #bfbfbf;
        padding: 20px 30px;
        text-align: center;
        font-size: 1.3rem;
      }
    }

    .gh-strong {
      font-weight: 800;
    }

    .gh-price {
      font-size: 1.3rem;
      font-weight: 600;
    }

    .term-checkbox {
      font-weight: 500;
      display: flex;
      align-items: flex-start;

      a {
        text-decoration: underline;
      }
    }

    .gh-right {
      padding-top: .4rem;

      .el-row {
        .el-col {
          font-weight: 600;
        }
      }
    }

    .gh-button {
      font-size: 1.1rem;
      font-weight: 700;
    }


    .gh-bold {
      font-weight: 900;
    }

    .gh-boxes {
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-height: 80px;
    }

    .gh-box-price {
      font-size: 1.2rem;
      font-weight: 900;
    }

    .gh-hint {
      font-size: 1.7rem;
      font-weight: 600;
      color: #474F59;
      position: absolute;
      top: 2rem;
    }

    .tnc {
      a {
        color: #474F59;
      }

      .gh-price {
        font-size: 2rem;
        color: #F76B6B;
      }
    }

    @media (max-width: 1023px) {
      .gh-right {
        padding-top: 2rem;
      }
    }

    @media (max-width: 991px) {
      .gh-subheading {
        margin-bottom: 1rem;
      }
      .gh-box-price-value {
        // margin-left: 3.5rem !important;

      }
    }

    @media (max-width: 767px) {
      .el-radio-group {
        margin-top: -1rem !important;

        .gh-row-radio-group {
          flex-flow: column;
          align-items: center;

          .gh-col-radio-group {
            margin-top: 2rem;
            max-width: 400px;
          }
        }
      }
    }

    .backing {
      position: absolute;
      background-color: #d4d1d17a;
      z-index: 4;
      height: calc(100% + 4px);
      width: calc(100% + 4px);
      margin-left: -25px;
      margin-top: -2px;
      border-radius: 10px;

      #closeText {
        transform: translate(0, 65%) rotate(-17deg);
        color: #f16c6d;
        text-align: center;
        padding: .8rem 0;
        &::before {
            position: absolute;
            content: "";
            left:8px;
            top: 0;
            height: 5px;
            width: 105%;
            border-top: 3px #f16c6d solid;
        }
        &::after {
            position: absolute;
            right: 5px;
            content: "";
            bottom: 10px;
            height: 8px;
            width: 105%;
            border-bottom: 3px #f16c6d solid;
        }
        @media(max-width:480px) {
          position: relative;
          top: 2rem;
          font-size: 2rem;
          &::after {
            right: -5px;
          }
          &::before {
            left: -2px;
          }
        }
    }
  }
</style>
<style lang="scss">
    .el-input {
      padding-top: 5px;
      padding-bottom: 5px;

      .el-input__inner {
        height: 52px !important;
        border-radius: 5px;
      }
    }

    .gh-form-registration-summit {
      .gh-form__section {
        .el-input {
          padding-top: 5px;
          padding-bottom: 5px;

          .el-input__inner {
            background: white;
            font-size: 1.1rem;
            height: 52px !important;
            border-color: #E6E6E6;
          }

          .el-input__inner:focus {
            border: 2px solid #F76B6B;
            border-radius: 8px;
          }
        }
      }

      .gh-stripe__element {
        background: white;
        color: blue;
        height: 52px;
        padding: 1.1rem;
        border-color: #E6E6E6;
        margin-top: 8px;
      }

      .ElementsApp .InputElement {
        font-size: 15px;
        color: #A0A4A9 !important;
      }

      .el-radio__label {
        font-size: 1.05rem;
      }

      .el-radio__input .el-radio__inner {
        width: 20px;
        height: 20px;
        top: 2.5rem;
      }

      .el-radio__input.is-checked .el-radio__inner {
        border-color: #CCCCCC;
        background: white !important;

        &::after {
          background-color: #f76c6c;
          width: 9px;
          height: 9px
        }
      }

      .el-checkbox__input .el-checkbox__inner {
        margin-top: .1rem;
      }

      .term-checkbox {
        .el-checkbox__label {
          font-size: 1.05rem;
        }
        a {
          font-family: proxima-nova,sans-serif;
        }
      }

      .el-select {
        i {
          color: #F76B6B !important;
        }
      }
    }

    .gh-summit-tooltip {
      max-width: 500px;
      @media (max-width: 480px) {
        max-width: 300px;
      }
    }

    #gh-registration-from__banner {
      margin-bottom: 0 !important;
    }

    .gh-form-registration-suicidePreventionSummit {
      @media screen and (max-width: 767px) {
        .el-radio-group {
          .gh-row-radio-group {
            flex-flow: column;
          }

          .gh-col-radio-group {
            + .gh-col-radio-group {
              margin-top: 2rem;
            }
          }
        }
      }

    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      // IE10+ CSS here
      .el-radio-group {
        .gh-col-radio-group {
          display: block !important;

          .gh-box {
            height: 100%;
          }
        }
      }
    }

    @media (max-width: 820px) {
      .gh-box-price-value {
        right: 12rem !important;
        top: 3rem !important;
      }

      .gh-includes {
        padding-top: 9rem !important;
      }
    }

    @media (max-width: 768px) {
      .gh-box-price-value {
        right: 13rem !important;
      }
    }

    @media (max-width: 480px) {
      .gh-box-price-value {
        right: 100px !important;
        top: 0 !important;
      }

      .gh-includes {
        padding-top: 5rem !important;
      }

      .el-radio-group .gh-row-radio-group .gh-col-radio-group {
        padding: 0 !important;
      }
    }
</style>
